import { useEffect } from "react";
import { Link } from "react-router-dom";
import Seo from "../../Seo";
import { SITE_ORIGIN } from "../../../config/site";
import L from "../../../constants/baysportLabels";
import { TRIAL_DAYS } from "../../../constants/trial";
import { trackTryClick } from "../../../analytics/metrikaGoals";
import { yandexMetrikaParams } from "../../../analytics/yandexMetrika";
import MarketingShell from "../MarketingShell";
import { MARKETING_PATHS } from "../marketingNav";
import s from "../marketing.module.css";

const PATH = MARKETING_PATHS.features;

const BLOCKS = [
  {
    id: "journal",
    title: "Журнал и расписание",
    text: "Отметки на занятии с телефона, группы и календарь тренировок.",
    items: [
      "Список группы на конкретное занятие",
      "Списание абонемента после отметки",
      "Повторяющееся расписание",
      "История посещений ученика",
    ],
    moreTo: "/zhurnal-poseshchaemosti",
    moreLabel: "Лендинг журнала",
  },
  {
    id: "memberships",
    title: "Абонементы и оплаты",
    text: "Типы пакетов, должники, выручка и онлайн-оплата своими ключами.",
    items: [
      "Пакеты занятий и периоды",
      "Список должников",
      "Наличные, перевод и карта",
      "Активация после оплаты",
    ],
    moreTo: "/abonementy",
    moreLabel: "Лендинг абонементов",
  },
  {
    id: "crm",
    title: "CRM и работа с клиентами",
    text: "База учеников и родителей, чат, задачи секции без Excel.",
    items: [
      "Карточки клиентов и семейные аккаунты",
      "Чат клуба",
      "Роли тренеров и администраторов",
      "Контроль наполняемости групп",
    ],
    moreTo: "/crm-dlya-sportivnogo-kluba",
    moreLabel: "Лендинг CRM",
  },
  {
    id: "app",
    title: "Кабинеты и приложение клуба",
    text: "PWA под вашим брендом для родителей и тренеров — без магазина приложений.",
    items: [
      "Кабинет родителя: расписание и остаток",
      "Кабинет тренера: свои группы",
      "Оформление портала под клуб",
      "Установка на главный экран",
    ],
    moreTo: "/sozdat-prilozhenie-dlya-kluba",
    moreLabel: "Лендинг приложения",
  },
];

export default function FeaturesPage() {
  useEffect(() => {
    yandexMetrikaParams({ landing: "features" });
  }, []);

  const onTry = () => trackTryClick({ landing: "features" });

  return (
    <MarketingShell metrikaLanding="features">
      <Seo
        title={`Возможности ${L.productName} — журнал, абонементы, CRM, PWA`}
        description={`${L.productName}: журнал посещаемости, абонементы, CRM секции и приложение клуба для родителей. ${TRIAL_DAYS} дней бесплатно.`}
        canonicalUrl={`${SITE_ORIGIN}${PATH}`}
        keywords={[
          "возможности crm спортивный клуб",
          "журнал посещаемости",
          "абонементы секция",
          "приложение для спортивного клуба",
        ]}
      />

      <section className={s.pageHero}>
        <div className={s.pageHeroInner}>
          <p className={s.eyebrow}>Возможности</p>
          <h1>Всё для управления секцией</h1>
          <p>
            Не набор разрозненных сервисов, а один контур: занятие → отметка →
            абонемент → кабинет родителя.
          </p>
          <div className={s.heroActions}>
            <Link
              to={MARKETING_PATHS.buy}
              className={`${s.btn} ${s.btnPrimary} ${s.btnLg}`}
              onClick={onTry}
            >
              Попробовать {TRIAL_DAYS} дней
            </Link>
            <Link to={MARKETING_PATHS.pricing} className={`${s.btn} ${s.btnOutline} ${s.btnLg}`}>
              Тарифы
            </Link>
          </div>
        </div>
      </section>

      <section className={s.section}>
        {BLOCKS.map((block) => (
          <article key={block.id} id={block.id} className={s.featureBlock}>
            <div>
              <h3>{block.title}</h3>
              <p>{block.text}</p>
              <Link to={block.moreTo} className={`${s.btn} ${s.btnOutline}`}>
                {block.moreLabel}
              </Link>
            </div>
            <ul>
              {block.items.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </article>
        ))}
      </section>

      <section className={s.ctaBand}>
        <h2>Проверьте на своей группе</h2>
        <p>{TRIAL_DAYS} дней полного доступа. Карту указывать не нужно.</p>
        <Link
          to={MARKETING_PATHS.buy}
          className={`${s.btn} ${s.btnPrimary} ${s.btnLg}`}
          onClick={onTry}
        >
          Создать клуб
        </Link>
      </section>
    </MarketingShell>
  );
}
